/* ====================================================================
   CLUB THEME PALETTES

   The 60/30/10 rule: c60 is the page background, c30 the primary brand
   colour (headers, nav), c10 the accent used for primary actions.
   Defaults match the built-in GreenSheet palette so existing clubs look
   identical until they set their own colours.
   ==================================================================== */

export const DEFAULT_THEME = { c60: '#eef3f1', c30: '#2f6f63', c10: '#d2872b' };

export const THEME_PRESETS = [
  { name: 'Classic Dark',   c60: '#eceff1', c30: '#37474f', c10: '#2f6f63' },
  { name: 'GreenSheet',     c60: '#eef3f1', c30: '#2f6f63', c10: '#d2872b' },
  { name: 'Forest & Gold',  c60: '#f0f4f0', c30: '#2e7d32', c10: '#f9a825' },
  { name: 'Navy & Red',     c60: '#f4f6fb', c30: '#1a237e', c10: '#c62828' },
  { name: 'Maroon & Gold',  c60: '#faf5f5', c30: '#880e4f', c10: '#ffd600' },
  { name: 'Teal & Amber',   c60: '#f0fafa', c30: '#00695c', c10: '#ff8f00' },
  { name: 'Royal & Silver', c60: '#f4f6ff', c30: '#283593', c10: '#546e7a' },
  { name: 'Slate & Orange', c60: '#f5f5f5', c30: '#37474f', c10: '#e64a19' },
];
